export const minPriceOptions = [
  { display: 'Min price: --', value: 0 },
  { display: '100k', value: 100000 },
  { display: '125k', value: 125000 },
  { display: '150k', value: 150000 },
  { display: '175k', value: 175000 },
  { display: '200k', value: 200000 },
  { display: '225k', value: 225000 },
  { display: '250k', value: 250000 },
  { display: '275k', value: 275000 },
  { display: '300k', value: 300000 },
  { display: '325k', value: 325000 },
  { display: '350k', value: 350000 },
  { display: '375k', value: 375000 },
  { display: '400k', value: 400000 },
  { display: '425k', value: 425000 },
  { display: '450k', value: 450000 },
  { display: '475k', value: 475000 },
  { display: '500k', value: 500000 },
  { display: '600k', value: 600000 },
  { display: '700k', value: 700000 },
  { display: '800k', value: 800000 },
  { display: '900k', value: 900000 },
  { display: '1M', value: 1000000 },
  { display: '2M', value: 2000000 },
  { display: '5M', value: 5000000 },
  { display: '10M', value: 10000000 }
]

export const maxPriceOptions = [
  { display: 'Max price: --', value: '' },
  { display: '100k', value: 100000 },
  { display: '125k', value: 125000 },
  { display: '150k', value: 150000 },
  { display: '175k', value: 175000 },
  { display: '200k', value: 200000 },
  { display: '225k', value: 225000 },
  { display: '250k', value: 250000 },
  { display: '275k', value: 275000 },
  { display: '300k', value: 300000 },
  { display: '325k', value: 325000 },
  { display: '350k', value: 350000 },
  { display: '375k', value: 375000 },
  { display: '400k', value: 400000 },
  { display: '425k', value: 425000 },
  { display: '450k', value: 450000 },
  { display: '475k', value: 475000 },
  { display: '500k', value: 500000 },
  { display: '600k', value: 600000 },
  { display: '700k', value: 700000 },
  { display: '800k', value: 800000 },
  { display: '900k', value: 900000 },
  { display: '1M', value: 1000000 },
  { display: '2M', value: 2000000 },
  { display: '5M', value: 5000000 },
  { display: '10M', value: 10000000 }
]

export const minAreaOptions = [
  { display: 'Square Feet: --', value: 0 },
  { display: '500+', value: 500 },
  { display: '1000+', value: 1000 },
  { display: '1500+', value: 1500 },
  { display: '2000+', value: 2000 },
  { display: '2500+', value: 2500 },
  { display: '3000+', value: 3000 },
  { display: '3500+', value: 3500 },
  { display: '4000+', value: 4000 },
  { display: '5000+', value: 5000 },
  { display: '6000+', value: 6000 },
  { display: '7000+', value: 7000 },
  { display: '8000+', value: 8000 },
  { display: '9000+', value: 9000 }
]

export const sortOptions = [
  { display: 'Sort: Newest', value: '-listdate' },
  { display: 'Sort: Oldest', value: 'listdate' },
  { display: 'Sort: Highest Price', value: '-listprice' },
  { display: 'Sort: Lowest Price', value: 'listprice' }
]

export const minBedOptions = [
  { display: 'Beds: --', value: 0 },
  { display: '1+', value: 1 },
  { display: '2+', value: 2 },
  { display: '3+', value: 3 },
  { display: '4+', value: 4 },
  { display: '5+', value: 5 },
  { display: '6+', value: 6 }
]

export const minBathOptions = [
  { display: 'Baths: --', value: 0 },
  { display: '1+', value: 1 },
  { display: '2+', value: 2 },
  { display: '3+', value: 3 },
  { display: '4+', value: 4 },
  { display: '5+', value: 5 },
  { display: '6+', value: 6 }
]

export const typeOptions = [
  { display: 'Type: --', value: '' },
  { display: 'residential', value: 'residential' },
  { display: 'rental', value: 'rental' },
  { display: 'condominium', value: 'condominium' }
]



// WEBPACK FOOTER //
// ./src/data/filters.js